/**
 * Meta Pixel event helpers. Call these when user actions occur.
 * Requires the pixel base code in index.html.
 */

export function trackContact() {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "Contact");
  }
}

export function trackInitiateCheckout(options = {}) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "InitiateCheckout", options);
  }
}

export function trackSubscribe(options = {}) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "Subscribe", options);
  }
}
